export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-shopping-cart-d4c957621b94d0b609865522632e62df.svg";